import angular from 'angular';
import * as R from 'ramda';

export default function SelectAdvisoryReportTypesDialogController(
  $rootScope,
  $scope,
  $q,
  ssDialogService,
  loaderService,
  reportsDataService,
  alerts,
  selectEditTypeDialog,
  selectAdvisoryReportParametersDialog,
) {
  const vm = this;

  vm.hasData = false;
  vm.appIsLoaded = false;
  
  vm.selectedAll = false;

  vm.selectedEditTypeId = 1;

  vm.handleGoBack = _handleGoBack;
  vm.handleSubmit = _handleSubmit;
  vm.handleCloseDialog = _handleCloseDialog;

  vm.handleSelectAll = _handleSelectAll;  

  _activate();

  // //////// METHODS //////////

  function _activate() {
    return _getAdvsoryReportTypes().then(() => {
      vm.appIsLoaded = true;
    });
  }

  function _getAdvsoryReportTypes() {
    loaderService.showViewLoader = true;

    return $q.all([
      reportsDataService.getAdvisoryReportSummary(),
      reportsDataService.getReportParameterAdvisoryReportTypesByReportPackage(vm.reportPackage.reportPackageId, false),
    ]).then(response => {

      vm.advisoryReportTypes = response[0].data.result;      
      const selectedReportTypes = response[1].data.result;
      
      angular.forEach(vm.advisoryReportTypes, (reportType, rtIndex) => {
        angular.forEach(selectedReportTypes, (selectedReportType, srtIndex) => {
          if (reportType.reportGroupId === selectedReportType.reportGroupId) {
            reportType.isSelected = true;
          }
        });
      });

      if ((vm.advisoryReportTypes !== null) && (vm.advisoryReportTypes.length > 0)) {
        vm.hasData = true;
      }

      loaderService.showViewLoader = false;
    });
  }

  function _handleGoBack($event) {
    ssDialogService.hide(ssDialogService.dialogs.reports.selectAdvisoryReportTypesDialog);
    
    ssDialogService.dialogs.reports.selectEditTypeDialog = ssDialogService.alert(
      selectEditTypeDialog.getOptions($event, {
        hasAdvisoryServices: vm.hasAdvisoryServices,
        reportPackage: vm.reportPackage,
        selectedEditTypeId: 1,
        attachCallback: vm.documentAttached,
      }),
    );
    return ssDialogService.show(ssDialogService.dialogs.reports.selectEditTypeDialog);
  }

  function _handleSubmit($event) {

    let selectedReportTypes = [];

    angular.forEach(vm.advisoryReportTypes, (reportType, index) => {
      if (reportType.isSelected) {
        reportType.reportPackageId = vm.reportPackage.reportPackageId;
        selectedReportTypes.push(reportType);
      }
    });

    _saveSelectedReportTypes(vm.reportPackage.reportPackageId, selectedReportTypes).then(() => {
      if (vm.saveType === 'saveAndSelectParameters') {
        _handleCloseDialog();
        ssDialogService.dialogs.reports.selectAdvisoryReportParametersDialog = ssDialogService.alert(
          selectAdvisoryReportParametersDialog.getOptions($event, {
            hasAdvisoryServices: vm.hasAdvisoryServices,
            reportPackageId: vm.reportPackage.reportPackageId,
            reportPackage: vm.reportPackage,
            editMode: 1,
          }),
        );
        return ssDialogService.show(ssDialogService.dialogs.reports.selectAdvisoryReportParametersDialog);
      }
    });
  }

  function _handleCloseDialog() {
    ssDialogService.hide(ssDialogService.dialogs.reports.selectAdvisoryReportTypesDialog);
  }
  
  function _handleSelectAll() {
    R.forEach((reportType) => {
        reportType.isSelected = vm.selectAll;
      }, vm.advisoryReportTypes );
  } 

  function _saveSelectedReportTypes(reportPackageId, selectedReportTypes) {
    loaderService.showViewLoader = true;
    const dfdSave = $q.defer();

    if ((reportPackageId !== null) && (reportPackageId > 0)) {
      reportsDataService.saveBulkReportParameterAdvisoryReportTypes(reportPackageId, selectedReportTypes).then((response) => {
        const savedReportPackage = response.data;
        if (savedReportPackage === 'undefined' || savedReportPackage === false) {
          // There was an error saving the Report Package information
          alerts.error('Error occurred while saving the Report Package Selected Reports.');
          loaderService.showViewLoader = false;
          dfdSave.reject();
        } else {
          // The Report Package Selected Reports information has been saved
          alerts.success('The Report Types included in the Package have been updated successfully.');
          $rootScope.$broadcast('refreshReportPackageConfiguration', {
            reportPackageId: Number(reportPackageId),
          });  
          loaderService.showViewLoader = false;
          dfdSave.resolve();
        }
      });
    } else {
      loaderService.showViewLoader = false;
      dfdSave.reject();
    }

    return dfdSave.promise;
  }
}

SelectAdvisoryReportTypesDialogController.$inject = [
  '$rootScope',
  '$scope',
  '$q',
  'ssDialogService',
  'loaderService',
  'reportsDataService',
  'alerts',
  'selectEditTypeDialog',
  'selectAdvisoryReportParametersDialog',
];
